export default "/assets/images/slide-mini-lg.d7e9dbc00790de17.jpg";